import type { NextPage } from 'next';
import Head from 'next/head';
import InsightsComponent from '@components/expertise/insights/insights';
import { MetaTags } from '@helpers/meta-tags.helper';
import MainLayout from '@layouts/main-layout/main-layout';

const Insights: NextPage = () => {
    return (
        <>
            <Head> {
                MetaTags({
                    title: 'How We Build Software: Agile, SDLC & Discovery Process | Agilie',
                    description: 'Explore Agilie’s approach to software development through Agile, SDLC, and Discovery to deliver efficient, scalable, and user-focused solutions.',
                    imageUrl: '/insights-images/technology-insights-image-meta.png',
                })
            }
                <link rel="icon" href="/favicon.ico" />
            </Head>
            <MainLayout>
                <InsightsComponent />
            </MainLayout>
        </>
    )
}

export default Insights;
